import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'qaroni-title-subtitle',
  templateUrl: './title-subtitle.component.html',
  styleUrls: ['./title-subtitle.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TitleSubtitleComponent {}
